export type ToastType = 'success' | 'error' | 'info';

type Emit = (message: string, durationMs?: number) => void;

/**
 * Bề mặt bắn toast. Khai ở ĐÂY (file không phụ thuộc React) để cả provider lẫn
 * interceptor axios cùng dùng một kiểu — hai bản song song thì thêm một mức toast
 * ở một bên là bên kia lặng lẽ hết khớp.
 */
export interface ToastApi {
  success: Emit;
  error: Emit;
  info: Emit;
}

/**
 * Cầu nối cho code NGOÀI React (interceptor axios) bắn toast.
 *
 * Tách khỏi ToastContext để cắt vòng import: `api.ts` cần toast, còn
 * `ToastContext.tsx` là component nên (gián tiếp) cần `api.ts`.
 */
let sink: ToastApi | null = null;

export function setToastSink(api: ToastApi | null): void {
  sink = api;
}

export const showToast: ToastApi = {
  success: (message, duration) => sink?.success(message, duration),
  error: (message, duration) => sink?.error(message, duration),
  info: (message, duration) => sink?.info(message, duration),
};
